const actions = {
  async createBroadcast({dispatch},data) {
    let res = await dispatch('api/nav/adminBroadcast', [data.title, data.message])
    if(!res.success) dispatch('popups/show/error')
    else dispatch('analytics/createBroadcast', data)
  },
};

export default {
  actions
};
